import { config } from "../config";

import logoMulticedi from "../assets/images/logo-icon-multicedi.png";
import logoApulia from "../assets/images/logo-icon-apulia-distribuzione.png";

import bgMulticedi from "../assets/images/big/auth-bg-multicedi.jpg";
import bgApulia from "../assets/images/big/auth-bg-apulia-distribuzione.jpg";

// export class Layout {
  

//   getLogo() {
//     let logo = null;
//     switch(config.instance.id) {
//       case "multicedi": logo = logodTcs; break;
//       case "apulia-distribuzione": logo = logodApulia; break;
//       default:
//         throw new Error("Invalid config.instance.id - log not found")
//     }

//     return logo;
//   }
// }

export const getLogo = () => {
  let logo = null;
  switch(config.instance.id) {
    case "multicedi": logo = logoMulticedi; break;
    case "apulia-distribuzione": logo = logoApulia; break;
    default:
      throw new Error("Invalid config.instance.id - logo not found")
  }

  return logo;
}

export const getAuthBackgrpund = () => {
  let bg = null;
  switch(config.instance.id) {
    case "multicedi": bg = bgMulticedi; break;
    case "apulia-distribuzione": bg = bgApulia; break;
    default:
      throw new Error("Invalid config.instance.id - background not found")
  }

  return bg;
}

export const getShortName = () => {
  let name = null;
  switch(config.instance.id) {
    case "multicedi": name = "T.C.S."; break;
    case "apulia-distribuzione": name = "S.O.V."; break;
    default:
      throw new Error("Invalid config.instance.id - short name not found")
  }

  return name;
}